import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function Contactnav() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const PLAY_STORE_URL =
    "https://play.google.com/store/apps/details?id=com.solo_connect.app&pcampaignid=web_share";

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close menu on route change
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const isActive = (path) => location.pathname.toLowerCase() === path.toLowerCase();

  const navLinks = [
    { label: "Home", path: "/" },
    { label: "Trip Suggestions", path: "/trip-suggestions" },
    { label: "Blog", path: "/blog" },
    { label: "About us", path: "/about-us" },
    { label: "FAQ", path: "/faq" },
  ];

  return (
    <nav
      className={`fixed w-full top-0 z-50 bg-white transition-shadow duration-300 ${
        scrolled ? "shadow-md" : "shadow-sm"
      }`}
      style={{ borderBottom: "1px solid rgba(0,0,0,0.07)" }}
    >
      <div className="flex items-center justify-between px-5 md:px-16 py-3">
        {/* Logo */}
        <a href="/" className="flex-shrink-0">
          <img
            src="/img/shared/Group 1707478797.jpg"
            alt="SoloConnect Logo"
            className="h-10 w-[130px] object-contain"
          />
        </a>

        {/* Desktop Nav Links */}
        <div className="hidden md:flex items-center gap-8 text-sm font-medium">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.path}
              className={`transition-colors duration-200 ${
                isActive(link.path)
                  ? "text-[#7209B7] font-semibold"
                  : "text-[#000000B2] hover:text-[#7209B7]"
              }`}
            >
              {link.label}
            </a>
          ))}
        </div>

        {/* Desktop Download Button */}
        <button
          onClick={() => window.open(PLAY_STORE_URL, "_blank")}
          className="hidden md:block bg-[#7209B7] text-white text-sm font-semibold px-6 py-2.5 rounded-full hover:bg-[#5a07a0] active:scale-95 transition-all duration-200 shadow-sm flex-shrink-0"
        >
          Download Now
        </button>

        {/* Mobile Hamburger Button */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="md:hidden flex flex-col justify-center items-center gap-[5px] p-2 rounded-md hover:bg-purple-50 transition-colors duration-200"
          aria-label="Toggle menu"
        >
          <span
            className={`block w-6 h-[2px] bg-[#7209B7] rounded transition-all duration-300 ${
              menuOpen ? "rotate-45 translate-y-[7px]" : ""
            }`}
          />
          <span
            className={`block w-6 h-[2px] bg-[#7209B7] rounded transition-all duration-300 ${
              menuOpen ? "opacity-0" : ""
            }`}
          />
          <span
            className={`block w-6 h-[2px] bg-[#7209B7] rounded transition-all duration-300 ${
              menuOpen ? "-rotate-45 -translate-y-[7px]" : ""
            }`}
          />
        </button>
      </div>

      {/* Mobile Dropdown Menu */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-300 bg-white ${
          menuOpen ? "max-h-96 border-t border-gray-100" : "max-h-0"
        }`}
      >
        <div className="flex flex-col px-5 py-3 gap-1">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.path}
              className={`py-3 px-3 rounded-lg text-sm font-medium transition-colors duration-200 ${
                isActive(link.path)
                  ? "text-[#7209B7] font-semibold bg-purple-50"
                  : "text-[#000000B2] hover:text-[#7209B7] hover:bg-purple-50"
              }`}
            >
              {link.label}
            </a>
          ))}
          {/* Mobile Download Button */}
          <button
            onClick={() => window.open(PLAY_STORE_URL, "_blank")}
            className="mt-3 mb-2 bg-[#7209B7] text-white text-sm font-semibold px-6 py-3 rounded-full hover:bg-[#5a07a0] active:scale-95 transition-all duration-200 w-full"
          >
            Download Now
          </button>
        </div>
      </div>
    </nav>
  );
}
